import Vue from 'vue';
import router from './route';
import Vuex from 'vuex';
import store from './store';
import Vant from './lib/vant';
import App from './app';

import './assets/css/index.css';
import './assets/font/iconfont.css';
import './assets/scss/index.scss';
import 'vant/lib/icon/local.css';

import init from './tools/init';

import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

if (process.env.NODE_ENV === 'production') {
  Raven
    .config('https://74bc6d03d17d477ead50db3eced62425@f-log.sinopharm-bio.com/2', {
      ignoreErrors: [
        /Script error/,
        /ReferenceError:.*/,
        /deviceScreenSize/,
        /setImageClickFunction/,
        /^unhandledrejection$/,
        /showSource/,
        /yiban/,
        /^unhandledrejection$/,
        /cancel/,
        /'trigger' of undefined/,
        /_promiseRejectionHandler/
      ],
      ignoreUrls: [/http:\/\/www\.yiban.cn/]
    })
    .addPlugin(RavenVue, Vue)
    .install();
}

// if (process.env.NODE_ENV === 'production') {
//   // 使用 fundebug
//   const fundebug = require('fundebug-javascript');
//   fundebug.apikey = '92d95b14c05d7eff0a67e0505722acb97b6d9e7b6033fab8e25fc0d8914f60ce';
//   fundebug.filters = [
//     {
//       message: /Script error/
//     },
//     {
//       message: /deviceScreenSize/
//     },
//     {
//       message: /setImageClickFunction/
//     },
//     {
//       message: /yiban/
//     },
//     {
//       message: /showSource/
//     },
//     {
//       req:
//         {
//           method: /^GET$/
//         },
//       res:
//         {
//           status: /^401$/
//         }
//     },
//     {
//       name: /^unhandledrejection$/
//     },
//     {
//       message: 'cancel'
//     }
//   ];
// }

init(Vue);

Vue.use(Vuex);
Vue.use(Vant);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

